import React from 'react';

import { SystemStyleObject, useMultiStyleConfig } from '@chakra-ui/react';

import { Box } from '../../../component-primitives/box';
import { Image } from '../../../component-primitives/image';
import { Heading, HeadingProps } from '../../heading';
import { Text, TextProps } from '../../text';
import { ModalHeaderBarPropType, ModalParts } from '../types';

const ModalHeaderBar = (props: ModalHeaderBarPropType) => {
  const { title, subTitle, leftImage, size } = props;

  const styles = useMultiStyleConfig('ModelHeaderBar', {
    size,
  }) as { [part in ModalParts]: SystemStyleObject };

  const sizes = {
    title: {
      default: 'title-md',
      small: 'title-sm',
    },
    subtitle: {
      default: 'body-md',
      small: 'body-sm',
    },
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mb: '5',
        ...styles.wrapper,
      }}
    >
      <Box display="flex" gap="2" alignItems="center" mb="2">
        {leftImage && <Image src={leftImage} alt="leftImage" />}
        <Heading
          size={sizes.title[size || 'default'] as HeadingProps['size']}
          sx={{ m: '0', ...styles.title }}
          as="header"
        >
          {title}
        </Heading>
      </Box>
      {subTitle && (
        <Text
          size={sizes.subtitle[size || 'default'] as TextProps['size']}
          variant="text-primary"
          sx={{ mt: 0, ...styles.subtitle }}
        >
          {subTitle}
        </Text>
      )}
    </Box>
  );
};

export { ModalHeaderBar };
